// O n8n distribui o contato entre os vendedores (round-robin) e redireciona para o wa.me da vez.
export const WHATSAPP_SALES_WEBHOOK_URL =
  process.env.WHATSAPP_SALES_WEBHOOK_URL ||
  'https://n8n-webhook.auto.api4com.com/webhook/8f04e5ef-57a6-4fd0-99c7-08df4849e374'

/**
 * URL do webhook com o domínio da conta (`?domain=`). Com ele o n8n procura no Pipedrive o
 * vendedor que já tem o lead; sem domínio, cai na roleta.
 */
export function salesWebhookUrlFor (domain) {
  if (!domain) return WHATSAPP_SALES_WEBHOOK_URL
  return `${WHATSAPP_SALES_WEBHOOK_URL}?domain=${encodeURIComponent(domain)}`
}



// WEBPACK FOOTER //
// ./src/utils/whatsapp.js